(() => {
  'use strict';
  const initialized = new WeakSet();
  function createContents(root, content) {
    if (root.dataset.autoToc !== 'true' || content.querySelector('.toc-wrapper, #toc, #table-of-contents, [data-toc]')) return;
    const headings = Array.from(content.querySelectorAll('h2'));
    if (!headings.length) return;
    const wrapper = document.createElement('nav');
    wrapper.className = 'toc-wrapper';
    wrapper.setAttribute('aria-label', 'В этой статье');
    const title = document.createElement('h2');
    title.className = 'toc-title';
    title.textContent = 'В этой статье:';
    const list = document.createElement('div');
    list.className = 'toc-list';
    headings.forEach((heading, index) => {
      if (!heading.id || document.getElementById(heading.id) !== heading) {
        let id = `${root.id}-contents-${index}`;
        while (document.getElementById(id)) id += '-heading';
        heading.id = id;
      }
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.dataset.list = '';
      const span = document.createElement('span');
      span.textContent = heading.textContent;
      link.append(span);
      list.append(link);
    });
    wrapper.append(title, list);
    headings[0].before(wrapper);
  }
  async function loadCard(container, handle) {
    const url = `/products/${encodeURIComponent(handle)}?view=article-cta`;
    let missingProduct = false;
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      missingProduct = response.status === 404;
      if (!response.ok) throw new Error('Товар недоступен');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = document.querySelector('.article-cta');
      if (!card || !card.querySelector('h6')?.textContent.trim()) throw new Error('Карточка товара недоступна');
      if (!container.isConnected) return;
      const styles = Array.from(document.querySelectorAll('style'));
      container.replaceChildren(...styles, card);
      container.dataset.state = 'ready';
    } catch (error) {
      if (!container.isConnected) return;
      const link = document.createElement('a');
      link.href = missingProduct ? '/collections/all' : `/products/${encodeURIComponent(handle)}`;
      link.className = 'btn2';
      link.textContent = missingProduct ? 'Посмотреть доступные товары' : 'Посмотреть товар';
      container.replaceChildren(link);
      container.dataset.state = 'unavailable';
    }
  }
  function replaceMarkers(content) {
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement.closest('script,style,code,pre') && node.textContent.includes('[cta:')) nodes.push(node);
    }
    nodes.forEach(node => {
      const matches = Array.from(node.textContent.matchAll(/\[cta:([a-zA-Z0-9][a-zA-Z0-9_-]*)\]/g));
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      const cards = [];
      let position = 0;
      matches.forEach(match => {
        fragment.append(node.textContent.slice(position, match.index));
        const container = document.createElement('span');
        container.className = 'cta-container';
        container.style.display = 'block';
        container.dataset.handle = match[1];
        container.dataset.state = 'loading';
        fragment.append(container);
        cards.push([container, match[1]]);
        position = match.index + match[0].length;
      });
      fragment.append(node.textContent.slice(position));
      node.replaceWith(fragment);
      cards.forEach(([container, handle]) => loadCard(container, handle));
    });
  }
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const content = root.querySelector('.article-content-wrapper');
    if (!content) return;
    content.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('nwb-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'nwb-table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Оглавление статьи');
      wrapper.tabIndex = 0;
      table.before(wrapper);
      wrapper.append(table);
    });
    replaceMarkers(content);
    createContents(root, content);
  }
  function start(scope) {
    if (scope.matches?.('[data-nwb-article]')) initialize(scope);
    scope.querySelectorAll('[data-nwb-article]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
